import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import { useState } from "react";
import { FormProvider, RHFTextField } from "src/components/hook-form";
import PasswordAdorment from "src/components/PasswordAdorment";

import { useChangePasswordForm } from "./hooks/useChangePasswordForm";

// ----------------------------------------------------------------------

export const ChangePasswordForm = () => {
	const [showPassword, setShowPassword] = useState(false);

	const { methods, onSubmit, isLoading } = useChangePasswordForm();

	const endAdornment = {
		endAdornment: (
			<PasswordAdorment
				showPassword={showPassword}
				onClick={() => setShowPassword(!showPassword)}
			/>
		)
	};

	return (
		<FormProvider methods={methods} onSubmit={onSubmit}>
			<Stack gap={2} sx={{ mt: 3 }}>
				<RHFTextField
					InputProps={endAdornment}
					label='Contraseña antigua'
					name='oldPassword'
					type={showPassword ? "text" : "password"}
				/>
				<RHFTextField
					InputProps={endAdornment}
					label='Nueva contraseña'
					name='newPassword'
					type={showPassword ? "text" : "password"}
				/>
				<RHFTextField
					InputProps={endAdornment}
					label='Confirma nueva contraseña'
					name='confirmNewPassword'
					type={showPassword ? "text" : "password"}
				/>
				<Stack flexDirection={"row"} justifyContent={"flex-end"} sx={{ mt: 1 }}>
					<LoadingButton loading={isLoading} type='submit' variant='contained'>
						{"Guardar cambios"}
					</LoadingButton>
				</Stack>
			</Stack>
		</FormProvider>
	);
};

export default ChangePasswordForm;
